const gradients = {
  blue1: "linear-gradient(135deg, #6B73FF 0%, #000DFF 100%)",
  blue2: "linear-gradient(135deg, #ABDCFF 0%, #0396FF 100%)",
  blue3: "linear-gradient(127.55deg, #141E30 3.73%, #243B55 92.26%)",
  orange1: "linear-gradient(135deg, #FCCF31 0%, #F55555 100%)",
  orange2: "linear-gradient(135deg, #FFD3A5 0%, #FD6585 100%)",
  purple1: "linear-gradient(135deg, #43CBFF 0%, #9708CC 100%)",
  pink1: "linear-gradient(135deg, #F6CEEC 0%, #D939CD 100%)",
  pink2: "linear-gradient(135deg, #F761A1 0%, #8C1BAB 100%)",
  green1: "linear-gradient(135deg, #FFF720 0%, #3CD500 100%)",
  black1: "linear-gradient(100.66deg, #434343 6.56%, #000000 93.57%)",
};

export default {
  computed: {
    $isMobileDevice() {
      return this.$vuetify.breakpoint.xsOnly;
    },

    $shadow() {
      if (this.$vuetify.theme.dark) {
        return "";
      } else {
        return "shadow";
      }
    },

    $darkMode() {
      return this.$vuetify.theme.dark;
    },

    $colors() {
      const theme = this.$darkMode ? "dark" : "light";
      return { ...this.$vuetify.theme.themes[theme], gradients };
    },
  },
};
